module.exports = __webpack_public_path__ + "public/img/tselevator.d5e3b198.png";